import { render, staticRenderFns } from "./PropertyEmailhandlerConfiguration.vue?vue&type=template&id=65a81bb8&scoped=true&"
import script from "./PropertyEmailhandlerConfiguration.vue?vue&type=script&lang=js&"
export * from "./PropertyEmailhandlerConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PropertyEmailhandlerConfiguration.vue?vue&type=style&index=0&id=65a81bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a81bb8",
  null
  
)

export default component.exports